import { datetimepicker } from 'eonasdan-bootstrap-datetimepicker';
import * as moment from 'moment';
import * as _ from "lodash";
import {
  Directive,
  ElementRef,
  Renderer,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { NgModel, NgControl } from '@angular/forms';
import { config } from '../../../../environments/config';

declare var jQuery: any;


@Directive({
  selector: '[appDateTimePicker]'
})
export class DateTimePickerDirective implements OnInit {
  constructor(public el: ElementRef) {}
  @Input('appDateTimePicker') options?: any = {};
  @Input('appDateTimePickerDate') date?: any = moment();
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    const dateFormat = this.options ? (this.options.dateFormat ? this.options.dateFormat : config.dateFormat) : config.dateFormat;
    //we are using bootstrap-daterangepicker in http://eonasdan.github.io/bootstrap-datetimepicker/Options/
    let dp = jQuery(this.el.nativeElement.parentNode).datetimepicker({
      sideBySide: true,
      allowInputToggle: true,
      format: dateFormat,
      ...(this.options ? _.omit(this.options, ['dateFormat']) : {})
    });
    let that = this;
    setTimeout(() => {
      if (moment(this.date).isValid()) {
        this.ngModelChange.emit(moment(this.date).toISOString());
      }
    });
    jQuery(this.el.nativeElement.parentNode).on ("dp.change", (e) => {
      this.ngModelChange.emit(moment(e.date).toISOString());
    });
    jQuery(this.el.nativeElement.parentNode).on ("dp.update", (e) => {
      this.ngModelChange.emit(moment(e.date).toISOString());
    });
  }

}
